var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({ height: _vm.height + 'px', 'border-radius': '5px' }),attrs:{"id":`${_vm.nameMap}_${_vm.initialDate}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }